
import Clarity from '@microsoft/clarity';
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CLARITY_PROJECT_ID } from '../../../project_config';
import { api } from "../../../utils/api";
import { LoginHelper } from "../../../utils/LoginHelper";
import EditorPageLayout from "../../common/editor/EditorPageLayout";
import Form from "./form/Form";

export default function EpisodeEdit() {
	Clarity.init(CLARITY_PROJECT_ID);
	const [isDesktop, setIsDesktop] = useState(() => window.innerWidth > 768);
	const params = useParams();
	const episodeId = params.episodeId;
	const [episode, setEpisode] = useState(null);
	const [errorMessage, setErrorMessage] = useState('');
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const onResize = () => setIsDesktop(window.innerWidth > 768);
		window.addEventListener("resize", onResize);
		return () => window.removeEventListener("resize", onResize);
	}, []);

	useEffect(() => {
		setIsLoading(true);
		api.episodeFetchEdit({
			token: LoginHelper.getToken(),
			episode_id: episodeId,
		}).then((result) => {
			setEpisode(result);
			setIsLoading(false);
		}).catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		});
	}, [episodeId]);

	const workshopId = episode?.workshop;
	const linkDataList = [
		{ label: 'خانه', href: '/' },
		{ label: 'کارگاه‌ها', href: '/workshop_list/' },
		...(workshopId
			? [{ label: 'کارگاه', href: `/workshop_detail/${workshopId}/` }]
			: []),
		{ label: 'ویرایش جلسه' },
	];

	return (
		<EditorPageLayout
			isDesktop={isDesktop}
			pageTitle="ویرایش جلسه"
			metaDescription="ویرایش جلسه کارگاه در همراهتیم"
			breadcrumbLinks={linkDataList}
			isLoading={isLoading}
			loadError={errorMessage && !episode ? errorMessage : ""}
		>
			{episode && <Form episode={episode} />}
		</EditorPageLayout>
	);
}
